import { ShoePrintIcon } from './ShoePrintIcon';

/**
 * author: Michael Irigoyen
 * id 4008AB1C-4D92-4D8B-9423-5182FC505664
 * name shoe-print
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shoe-print.svg
 * tags
 */
export const FootprintsIcon = ShoePrintIcon;
export default FootprintsIcon